export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14900.5982416f.jpg";